exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-text-icon[data-v-215a7954] {\n  float: right;\n  margin-right: 1rem;\n  margin-top: -2.15rem;\n  position: relative;\n  font-size: 120%;\n  z-index: 2;\n  color: #9E9E9E;\n}\ndiv[data-v-215a7954] ul li {\n  margin-left: 20px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-215a7954","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/serviceRequest/Booking.vue
// module id = 2058
// module chunks = 0